import React from 'react';
import { Button as MuiButton, ButtonProps } from '@mui/material';
import { Loader } from 'src/components/Button/styled';

interface Props extends ButtonProps {
  loading?: boolean;
}

export const Button = ({ loading, ...props }: Props) => {
  const { disabled, children } = props;

  return (
    <MuiButton {...props} disabled={disabled || loading}>
      {loading && <Loader size={24} />}
      {children}
    </MuiButton>
  );
};
